import useBootstrapData from '@/hooks/useBootstrapData'
import analytics from '@/shared-utils/analytics'
import fetchMultipleCityInfo from '@/shared-utils/fetch-multiple-city-info'
import type { CityId } from '@/types'
import { useQuery } from '@tanstack/react-query'

export default function useRecommendations(cityIdList?: ReadonlyArray<CityId>) {
  const {
    appName,
    appVersion,
    webstats: { clientGUID },
  } = useBootstrapData()
  const cityIds = cityIdList?.map((x) => x.label) ?? []
  const { data = [], error } = useQuery({
    queryKey: [cityIds, appName, appVersion, clientGUID, 'fetchMultipleCityInfo'],
    queryFn: async () => {
      const cityList = await fetchMultipleCityInfo(cityIds, appName, appVersion, clientGUID)
      return cityList
    },
    staleTime: Infinity,
    enabled: cityIds.length > 0,
    retry: 0,
  })

  if (error) {
    analytics.logError({
      message: 'Error thrown from useQuery',
      error: JSON.stringify(error),
      service: 'fetchMultipleCityInfo',
    })
  }

  return data
}
